<section class="container">
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse />
    <p class="body bold">Send your product</p>
  </section>

  <section>
    <p class="body mb-8">The next steps are:</p>
    <ul>
      <li><p class="body">We’ll post you the packaging, Freepost label and return note</p></li>
      <li>
        <p class="body">
          Put the return label in the package with your product and stick the Freepost label on the outside (front)
        </p>
      </li>
      <li><p class="body">Send it to us and we’ll keep you updated on the repair</p></li>
    </ul>
  </section>
</section>
